import { useState } from "react";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import { Typography } from "@mv-components/index";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useDispatch } from "react-redux";
import StorageUtil from "../../../utils/storageUtil";
import CreateIcon from "../Icon/Icon";
import { Icons } from "../../../utils/viewUtility";
import AuthService from "../../../utils/authService";
import { useNavigate } from "react-router-dom";
import routePaths from "../../../routes/routePaths";
import { LOG_OUT } from "../../../modules/auth/store/actionTypes";
import { styles } from "./styles";
import lang from "../../../core/constants/lang";
import useStyles from "@hooks/useStyle";

const UserProfile = () => {
	const userInfo = AuthService.getUserData();
	const navigate = useNavigate();
	const { classes, cx } = useStyles(styles) as any;
	const dispatch = useDispatch();
	const { displayName = "" } = userInfo ?? {};
	// const location = useLocation();
	const [anchorEl, setAnchorEl] = useState(null);

	const open = Boolean(anchorEl);

	const handleMenu = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLogout = () => {
		StorageUtil.removeAll();
		dispatch({ type: LOG_OUT });
		setAnchorEl(null);
		navigate(routePaths.LOGIN);
	};

	// const handleProfile = () => {
	// 	navigate(routePaths.PROFILE, location);
	// 	setAnchorEl(null);
	// };

	return (
		<>
			<Grid item className={classes.root}>
				<Grid container alignItems="center">
					<Grid item className={classes.padding10}>
						<Typography variant="caption" className={cx(classes.blackColor, classes.textUpperCase)}>
							{displayName}
						</Typography>
					</Grid>
					<Grid item className={classes.userInfoIcon}>
						<IconButton
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleMenu}
							color="inherit"
						>
							<AccountCircle className={classes.accountIcon} />
						</IconButton>
						<Menu
							anchorEl={anchorEl}
							className={classes.menuWrap}
							PaperProps={{ style: { paddingBottom: "0" } }}
							id="menu-appbar"
							open={open}
							onClose={handleClose}
						>
							{/* <MenuItem onClick={handleLogout}>
								<AccountCircle className={classes.profileIcon} />
								<Typography className={cx(classes.paddingLeft8, classes.colorDarkGrey)}>
									{lang.PROFILE}
								</Typography>
							</MenuItem> */}
							<MenuItem onClick={handleLogout}>
								<CreateIcon iconType={Icons.IC_LOG_OUT} className={classes.logOutIcon} />
								<Typography className={cx(classes.paddingLeft8, classes.colorDarkGrey)}>
									{lang.LOG_OUT}
								</Typography>
							</MenuItem>
						</Menu>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};
export default UserProfile;
